import { 
  DELETE_BRANDKIT_COMPONENT, UPDATE_BRANDKIT_COMPONENT_PROPERTY, 
  RENAME_BRANDKIT_COMPONENT, UPDATE_BRANDKIT_COMPONENT_CONTENT, ASSOCIATE_FONTS_WITH_BRANDKIT_COMPONENT,
  CREATE_BRANDKIT_COMPONENT_REQUEST, CREATING_BRANDKIT_COMPONENT_SUCCEEDED, CREATING_BRANDKIT_COMPONENT_FAILED,
  FETCHING_PALETTE_COMPONENT_EDITOR_REQUEST, FETCHING_PALETTE_COMPONENT_EDITOR_SUCCEEDED, FETCHING_PALETTE_COMPONENT_EDITOR_FAILED,
  FETCHING_BRANDKIT_COMPONENTS_REQUEST, FETCHING_BRANDKIT_COMPONENTS_SUCCEEDED, FETCHING_BRANDKIT_COMPONENTS_FAILED,
  UPDATE_PALETTE_COMPONENT_REQUEST, UPDATING_PALETTE_COMPONENT_SUCCEEDED, UPDATING_PALETTE_COMPONENT_FAILED,
  PUBLISH_PALETTE_COMPONENT_REQUEST, PUBLISHING_PALETTE_COMPONENT_SUCCEEDED, PUBLISHING_PALETTE_COMPONENT_FAILED,
  DELETE_BRANDKIT_COMPONENTS_REQUEST, DELETING_BRANDKIT_COMPONENTS_SUCCEEDED, DELETING_BRANDKIT_COMPONENTS_FAILED,
  UPDATE_BRANDKIT_COMPONENTS_REQUEST, UPDATING_BRANDKIT_COMPONENTS_SUCCEEDED, UPDATING_BRANDKIT_COMPONENTS_FAILED,
  INVALIDATE_PALETTE_COMPONENT,RELOAD_PALETTE_COMPONENT_ON_CHANGE, RENAME_PALETTE_COMPONENT_REQUEST,
  INVALIDATE_BRANDKIT_COMPONENT,
  RELOAD_EDITOR_BRAND_COMPONENT_SUCCEEDED
} from 'constants/actionTypes';
  
import { call, put, select, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';
import _ from 'lodash';
import { calculateOrderForWidgets } from 'components/Editor/helper/widget';
import { WidgetRegistry } from 'components/Editor/widgets/registry';
import { broadcastMessage } from 'components/Broadcaster';
import { PALETTE_COMPONENT_WIDGET } from 'constants/brandKit/component';
import {themes as DEFAULT_THEMES} from 'constants/themes';
import { createMixpanelEvent } from 'actions/mixpanel';
import { MIXPANEL_BRANDKIT_CREATED } from 'constants/mixpanelEvents';
  
  const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
  const BRANDKIT_COMPONENTS_URL = `${apiUrl}/api/2.0/palette`;


  export const deleteBrandkitNewComponents = createAction(DELETE_BRANDKIT_COMPONENT, (ids) => {
    return {
      ids: ids
    };
  });

  export const updateBrandkitComponentProperty = createAction(UPDATE_BRANDKIT_COMPONENT_PROPERTY, (id, widget_uid, property) => {
    return {
      id: id,
      widget_uid: widget_uid,
      property: property
    };
  });

  export const updateBrandkitComponentContent = createAction(UPDATE_BRANDKIT_COMPONENT_CONTENT, (id, widget_uid, content) => {
    return {
      id: id,
      widget_uid: widget_uid,
      content: content
    };
  });

  export const renameBrandkitComponent = createAction(RENAME_BRANDKIT_COMPONENT, (id, name) => {
    return {
      id: id,
      name: name
    };
  });

  export const associateFontWithBrandkitComponent = createAction(ASSOCIATE_FONTS_WITH_BRANDKIT_COMPONENT, (id, widget_uid, fonts) => {
    return {
      id: id,
      widget_uid: widget_uid,
      fonts: fonts
    };
  });

  /**
 * Create live element
*/
  export const createBrandkitComponent = createAction(CREATE_BRANDKIT_COMPONENT_REQUEST, (id, request, type) => {
    return {
      id: id,
      request: request,
      type: type
    };
  })

  const creatingBrandkitComponentSucceeded = createAction(CREATING_BRANDKIT_COMPONENT_SUCCEEDED, (response) => {
    return response;
  })

  const creatingBrandkitComponentFailed = createAction(CREATING_BRANDKIT_COMPONENT_FAILED, (error) => {
    return error;
  })

  function* createBrandkitComponentSaga(action) {
    const { id, request, type } = action.payload;

    let url = buildUrl(BRANDKIT_COMPONENTS_URL, {
      path: `/${id}/component`
    });
    const themes = DEFAULT_THEMES;

    const createBrandkitComponentAPI = (request) => {
      return axios.post(url, request).then(response => response.data);
    }
  
    try {
      const response = yield call(createBrandkitComponentAPI, {
        ...request,
        themes: themes
      });
  
      if (response) {
        yield put(creatingBrandkitComponentSucceeded(response));

        var mixpanelPayload = {
          brandkit_element_type: type
        }

        yield put(createMixpanelEvent(MIXPANEL_BRANDKIT_CREATED, mixpanelPayload))
        
      }
    } catch (error) {
      yield put(creatingBrandkitComponentFailed(error));
    }
  }

  export const invalidatePaletteComponent = createAction(INVALIDATE_PALETTE_COMPONENT);
  
  /**
   * Fetch live element for {id}
  */
    export const fetchPaletteComponent = createAction(FETCHING_PALETTE_COMPONENT_EDITOR_REQUEST, id => {
      return id;
    })

    const fetchPaletteComponentSucceeded = createAction(FETCHING_PALETTE_COMPONENT_EDITOR_SUCCEEDED, response => {
      return response;
    })

    const fetchingPaletteComponentFailed = createAction(FETCHING_PALETTE_COMPONENT_EDITOR_FAILED, (id, error) => {
      return {
        id: id,
        error: error
      }
    })

    function* fetchingPaletteComponentSaga(action) {
      const id = action.payload;

      let url = buildUrl(BRANDKIT_COMPONENTS_URL, {
        path: `/component/${id}`
      });

      const fetchingPaletteComponentAPI = () => {
        return axios.get(url).then(response => response.data);
      }

      try {
        const response = yield call(fetchingPaletteComponentAPI);
        yield put(fetchPaletteComponentSucceeded(response));
      } catch (error) {
        yield put(fetchingPaletteComponentFailed(id, error));
      }
    }


  /**
   * Fetch Brankit Components
  */
    export const fetchBrandkitComponents = createAction(FETCHING_BRANDKIT_COMPONENTS_REQUEST, id => {
      return id;
    })
    
    const fetchBrandkitComponentsSucceeded = createAction(FETCHING_BRANDKIT_COMPONENTS_SUCCEEDED, response => {
      return response;
    })
    
    const fetchingBrandkitComponentsFailed = createAction(FETCHING_BRANDKIT_COMPONENTS_FAILED, (id, error) => {
      return {
        id: id,
        error: error
      }
    })
    
    function* fetchingBrandkitComponentsSaga(action) {
      const id = action.payload;
    
      let url = buildUrl(BRANDKIT_COMPONENTS_URL, {
        path: id
      });
    
      const fetchingBrandkitComponentsAPI = () => {
        return axios.get(url).then(response => response.data);
      }
    
      try {
        const response = yield call(fetchingBrandkitComponentsAPI);
        yield put(fetchBrandkitComponentsSucceeded(response));
      } catch (error) {
        yield put(fetchingBrandkitComponentsFailed(id, error));
      }
    }
  
  

/**
 * Update palette component
*/
export const updatePaletteComponent = createAction(UPDATE_PALETTE_COMPONENT_REQUEST, (id, editorSession, callback) => {
  return {
    id: id,
    editorSession: editorSession,
    callback: callback
  }
});

const updatingPaletteComponentSucceeded = createAction(UPDATING_PALETTE_COMPONENT_SUCCEEDED, (id, response) => {
  return { id, response };
});

const updatingPaletteComponentFailed = createAction(UPDATING_PALETTE_COMPONENT_FAILED, (id, error) => {
  return { id, error };
});

function* updatePaletteComponentSaga(action) {
  const { id, editorSession } = action.payload;

  let url = buildUrl(BRANDKIT_COMPONENTS_URL, {
    path: `/component/${id}`
  });

  const updatePaletteComponentAPI = (request) => {
    return axios.put(url, request).then(response => response.data);
  }

  try {

    const snapshot = yield select(state => {

      var paletteComponent = _.get(state, `brandKit.components.paletteComponent[${id}].item`);
      var name = _.get(paletteComponent, 'name', '');
      var themes = _.get(state, `${editorSession}.present.themes`);
      var request = { name, themes };

      if (editorSession) {
        var widgets = _.get(state, `${editorSession}.present.widgets`) || [];

        widgets = widgets.filter(item => _.get(item, 'type') !== "cleverstory.v2.widgets.page");

        widgets = calculateOrderForWidgets(widgets, null);
        widgets = WidgetRegistry.processRequest(widgets);

        widgets = [PALETTE_COMPONENT_WIDGET, ...widgets];

        request = {
          ...request,
          widgets,
          themes,
        }
      }

      return request;
    });

    const response = yield call(updatePaletteComponentAPI, snapshot);
    if (response) {
      yield put(updatingPaletteComponentSucceeded(id, response));
    }

  } catch (error) {
    console.log(error);
    yield put(updatingPaletteComponentFailed(id, error));
  }
}


/**
 * Rename Palette Component
*/
export const renamePaletteComponent = createAction(RENAME_PALETTE_COMPONENT_REQUEST, (id, name) => {
  return {
    id: id,
    name: name,
  }
});

function* renamePaletteComponentSaga(action) {
  const { id, name } = action.payload;

  let url = buildUrl(BRANDKIT_COMPONENTS_URL, {
    path: `/component/${id}`
  });

  const renamePaletteComponentrAPI = (request) => {
    return axios.put(url, request).then(response => response.data);
  }

  try {
    const request = {
      name: name,
    }

    const response = yield call(renamePaletteComponentrAPI, request);
    if (response) {
      yield put(updatingPaletteComponentSucceeded(id, response));
    }

  } catch (error) {
    console.log(error);
    yield put(updatingPaletteComponentFailed(id, error));
  }
}


/**
 * Publish Live Element
*/
export const publishPaletteComponent = createAction(PUBLISH_PALETTE_COMPONENT_REQUEST, (id, callback) => {
  return {
    id: id,
    callback: callback
  }
})

const publishPaletteComponentSucceeded = createAction(PUBLISHING_PALETTE_COMPONENT_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
})

const publishPaletteComponentFailed = createAction(PUBLISHING_PALETTE_COMPONENT_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* publishPaletteComponentSaga(action) {
  const { id, callback } = action.payload;

  let url = buildUrl(BRANDKIT_COMPONENTS_URL, {
    path: `/component/${id}/publish`
  });

  const publishPaletteComponentAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(publishPaletteComponentAPI);
    yield put(publishPaletteComponentSucceeded(id, response));

    if (callback) {
      callback(response);
    }

    broadcastMessage(publishPaletteComponentSucceeded(id, response));

  } catch (error) {
    yield put(publishPaletteComponentFailed(id, error));
  }
}


  /**
   * Update Brankit Components
  */
    export const updateBrandkitComponents = createAction(UPDATE_BRANDKIT_COMPONENTS_REQUEST, (id, request) => {
      return {
        id: id,
        request: request
      }
    })
    
    export const updateBrandkitComponentsSucceeded = createAction(UPDATING_BRANDKIT_COMPONENTS_SUCCEEDED, (response) => {
      return {
        response: response
      }
    })
    
    export const updateBrandkitComponentsFailed = createAction(UPDATING_BRANDKIT_COMPONENTS_FAILED, (id, error) => {
      return {
        id: id,
        error: error
      }
    })
    
    function* updateBrandkitComponentsSaga(action) {
      const { id, request } = action.payload;
          
      let url = buildUrl(BRANDKIT_COMPONENTS_URL, {
        path: `/${id}`
      });
    
      const updateBrandkitComponentsAPI = () => {
        return axios.put(url, {components: request}).then(response => response.data);
      }

      try {
        const response = yield call(updateBrandkitComponentsAPI);
        if (response) {
          yield put(updateBrandkitComponentsSucceeded(response));
        }
      } catch (error) {
        yield put(updateBrandkitComponentsFailed(error));
      }
    }
  
  
  /**
   * Delete Brandkit Components
  */
    export const deleteBrandkitComponents = createAction(DELETE_BRANDKIT_COMPONENTS_REQUEST, (ids, paletteId) => {
      return {
        ids: ids,
        paletteId: paletteId
      }
    }) 
    
    const deleteBrandkitComponentsSucceeded = createAction(DELETING_BRANDKIT_COMPONENTS_SUCCEEDED, (ids, response) => {
      return {
        ids: ids,
        response: response
      }
    })
    
    const deleteBrandkitComponentsFailed = createAction(DELETING_BRANDKIT_COMPONENTS_FAILED, (ids, error) => {
      return {
        ids: ids,
        error: error
      }
    })
    
    function* deleteBrandkitComponentsSaga(action) {
      const {ids, paletteId} = action.payload;
    
      let url = buildUrl(BRANDKIT_COMPONENTS_URL, {
        path: `${paletteId}/component`
      });
    
      const deleteBrandkitComponentsAPI = () => {
        return axios.delete(url, {data: ids}).then(response => response.data);
      }
    
      try {
        const response = yield call(deleteBrandkitComponentsAPI);
        yield put(deleteBrandkitComponentsSucceeded(ids, response));
      } catch (error) {
        yield put(deleteBrandkitComponentsFailed(ids, error));
      }
    }
  
  export const reloadPaletteComponentOnChange = createAction(RELOAD_PALETTE_COMPONENT_ON_CHANGE, (element) => {
    return {element};
  })

  export const reloadEditorBrandSucceed = createAction(RELOAD_EDITOR_BRAND_COMPONENT_SUCCEEDED, (id, response, type) => {
    return {
      id,
      response,
      type
    };
  })

  export const invalidateBrandkitComponent = createAction(INVALIDATE_BRANDKIT_COMPONENT);

  
  
  export default function* brandkitComponentsSaga() {
    yield takeEvery(CREATE_BRANDKIT_COMPONENT_REQUEST, createBrandkitComponentSaga);
    yield takeEvery(FETCHING_PALETTE_COMPONENT_EDITOR_REQUEST, fetchingPaletteComponentSaga);
    yield takeEvery(FETCHING_BRANDKIT_COMPONENTS_REQUEST, fetchingBrandkitComponentsSaga);
    yield takeEvery(UPDATE_PALETTE_COMPONENT_REQUEST, updatePaletteComponentSaga);
    yield takeEvery(RENAME_PALETTE_COMPONENT_REQUEST, renamePaletteComponentSaga);
    yield takeEvery(PUBLISH_PALETTE_COMPONENT_REQUEST, publishPaletteComponentSaga);
    yield takeEvery(DELETE_BRANDKIT_COMPONENTS_REQUEST, deleteBrandkitComponentsSaga);
    yield takeEvery(UPDATE_BRANDKIT_COMPONENTS_REQUEST, updateBrandkitComponentsSaga);
  }